import { useEffect } from 'react';
import { UAParser } from 'ua-parser-js';
import { useCookies } from 'react-cookie';
import { UserInfoActions } from 'store/actionCreators';


export default function WrapperComponent(props) {
	const [cookies] = useCookies(); 
	let parserObj = new UAParser();
	const agentInfo = parserObj.getResult();
	const deviceInfo = parserObj.getDevice();
	const OSInfo = parserObj.getOS();
	const browserName = agentInfo['browser']['name'];
	
	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(()=>{ 
		UserInfoActions.updateDeviceInfo({deviceType: OSInfo['name']})
		if(['mobile','tablet'].includes(deviceInfo['type']))
		{
			UserInfoActions.updateDeviceInfo({isMobile : true})
			if((['Chrome WebView', 'WebKit'].includes(browserName) || cookies['push_token']) && (agentInfo?.ua && !agentInfo['ua'].includes('KAKAOTALK')))
			{
				UserInfoActions.updateDeviceInfo({isApp : true})
			}
			else
			{
				UserInfoActions.updateDeviceInfo({isApp : false})
			}
		}
		else
		{
			UserInfoActions.updateDeviceInfo({isMobile : false, isApp:false})
		}
	},[]);

	return null;
}